import { React, FC, useContext, DatePicker, useMemo, CustomDateInput  } from 'external/react'
import {clsx, styled} from 'external/material'
import {dayjs} from 'external/dayjs'
import { formatDate, parseDate, parseISO } from 'external/date-fns'
import { TimeRangePicker } from 'components/planning/plan-rd/components/TimeRangePicker'
import { TeacherContext } from 'teacher/context'

type DailyTimeInfo = {
    id: number
    dailyPlan: any
}

const StyledDailyTimeInfo = styled('div')(dailyTimeInfoStyles as any)

const DailyTimeInfo: FC<DailyTimeInfo> = (props) => {

    const {id} = props

    const {updateState, newPlan, translate, languageId} = useContext(TeacherContext) as any

    const { maxDate, minDate, dailyPlan, unavailableDates} = useMemo(() => {
      const maxDate = parseDate(newPlan.finish ?? '')
      const minDate = parseDate(newPlan.start ?? '')
      const dailyPlans = newPlan.content.dailyPlanning || []
      const dailyPlan:any = id >= 0 && id < dailyPlans.length ? dailyPlans[id] : {notFound: true}
      const unavailableDates: Date[] = dailyPlans.map((d:any) => parseDate(d.date)) ?? []
      return {maxDate, minDate, dailyPlan, unavailableDates}
    }, [newPlan.start, newPlan.finish, newPlan.content.dailyPlanning, id])

    const date: Date | undefined = useMemo(() => dailyPlan.date ? parseDate(dailyPlan.date) : undefined, [dailyPlan.date])

  function updateDailyPlan (commands:any) {
    updateState({newPlan: {content: {dailyPlanning: {[id]: commands}}}})
  }

  function updateDailyPlanDate (date: any) {
    updateDailyPlan({date: {$set: formatDate(date, 'yyyy-MM-dd', languageId)}})
  }

  function updateDailyPlanTime (timeProperty: 'start' | 'finish', value: dayjs.Dayjs ) {
    updateDailyPlan({[`${timeProperty}Time`]: {$set: value.toISOString()}})
  }

    return (
    <StyledDailyTimeInfo>
       <div className={clsx('info', 'date') }>
           <div className='label'>{translate('planning-rd-assigned-day')}</div>
           <DatePicker
             customInput={<CustomDateInput />}
             selected={date}
             onChange={updateDailyPlanDate}
             minDate={minDate}
             maxDate={maxDate}
             locale={languageId}
             popperPlacement="auto-start"
             excludeDates={unavailableDates}
           />
     </div>
    <div className={clsx('info', 'time')}>
      <TimeRangePicker
        label={translate('planning-rd-hour')}
        minTime={{ value: parseISO(dailyPlan.startTime), onChange: (time: any) => (time && updateDailyPlanTime('start', time)) }}
        maxTime={{ value: parseISO(dailyPlan.finishTime), onChange: (time: any) => (time && updateDailyPlanTime('finish', time)) }}
        />
    </div>
    </StyledDailyTimeInfo>
   )
}
    
export {DailyTimeInfo as default}

function dailyTimeInfoStyles() {
  const dateInput = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    cursor: 'pointer',
    width: '110px',
    padding: 0,
    textAlign: 'center',
    border: 'solid 1px #b8c1c7',
    height: '28px'
  }

  return {
    display: 'flex',
    gap: 20,
      "& .label": {
      color: 'rgba(0, 0, 0, 0.87)'
      },

    '& > .info': {
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center',
      '&.date': {
        flexShrink: 0,
      width: 200,
      gap: 8,
      height: '100%',
      boxSizing: 'border-box',
      "& .date-input": dateInput,
    },
    '&.time': {
      flexShrink: 0,
      "& .timerange-picker .picker": dateInput,
    }
  },
 }

}